export default __webpack_public_path__ + "maps-examples-multiple-images-1200-bdd29f883469c8e23fa8a59392da593f.webp";